 
 import React, { useEffect, useState } from "react";
 import styles from "../../../Pages/CreateAccount/CreateAccount.module.scss";
 import ErrorLabel from "../../../Components/Atoms/ErrorLabel/ErrorLabel";
 
 import {
   FormDropdown,
   FormField,
   FormFieldMail,
 } from "../../../Components/Molecules/FormField/FormField";
 import { useFormik } from "formik";
 import * as Yup from "yup";
 import { PrimaryButton } from "../../../Components/Atoms/Button/Button";
 import { useNavigate } from "react-router-dom";
 import { useLocation } from 'react-router-dom';
 import {set_password,admin_update_password, user_update_password} from "../../../Enums/api_constunts"
 import {postMethod} from "../../../Helpers/services"
 import _ from "lodash";
 import { showToast } from "../../../Components/Atoms/ToastNotifier/ToastNotifier";
 import { Modal, Button, Form } from 'react-bootstrap';
 import { useDispatch,useSelector } from "react-redux";

 export default function UpdatePassword({openUpdatepassword=false,SetOpenUpdatePassword}) {
    const userData = useSelector((state) => state.auth.user);
    const navigateTo = useNavigate();
  const [isSpinner, setIsSpinner] = useState(false);
  const [showModal, SetShowModal] = useState(openUpdatepassword==1);
  const location = useLocation();

  const handleSubmit = (values) => {
    setIsSpinner(true)
    
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const userId = queryParams.get('user_id');
    if(queryParams.get('customer')){
      values["customer"] = queryParams.get('customer')
    }
    
    values["token"] = token
    values["user_id"] = parseInt(userId)
    const url = admin_update_password;
    if (_.get(userData,"role_id",0)==5){
        url = user_update_password
    }
    // cpassword:'',
    //   password: "",
    //   confirm_password: "",
    let post_data = {
        "user_id": userData["id"],
        "old_password": values["cpassword"],
        "password": values["password"],
        "confirm_password":values["confirm_password"],
        "customer": userData["id"]
      }
      console.log(JSON.stringify(values))
    
    postMethod(url,post_data).then((result)=>{
      showToast("success",_.get(result, "message","Something went wrong!"))  
       setIsSpinner(false);
       SetOpenUpdatePassword(0)
       
     }).catch((error)=>{
       showToast("error",_.get(error, "message","Something went wrong!"))
       setIsSpinner(false);
       
     })
  };

  const formik = useFormik({
    initialValues: {
      cpassword:'',
      password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      cpassword:Yup.string().required("Please enter your current password"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")  // Minimum length should be 8
        .max(16, "Password cannot exceed 16 characters")
        .required("Please enter new password"),

      confirm_password: Yup.string()
        .min(8, "Confirmation Password must be at least 8 characters")  // Minimum length should be 8
        .max(16, "Confirmation Password cannot exceed 16 characters")
        .required("Please confirm your new password")
        .oneOf([Yup.ref("password"), null], "New passwords must match"),  // Ensure the confirmation password matches the password
    }),
    onSubmit: handleSubmit,
  });

//   useEffect(()=>{
//     if(openUpdatepassword==1){
//         setShowModal(true);
//     }else{
//         setShowModal(false);
//     }
    
//   },[openUpdatepassword])

const handleKeyDown = (event) => {
  
    
  if (event.key === 'Enter') {
    
    formik.handleSubmit()
    
  }
};
 
   return (
     
   
 
 
 <Modal  show={showModal} onHide={() => { SetOpenUpdatePassword(0)}} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Password</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <div className="row">
              
            <div className="d-flex flex-column justify-content-center align-items-center mt-3">
              
            <div className="mb-2" onKeyDown={handleKeyDown}>
                <FormField
                  label="Current Password"
                  id="cpassword"
                  name="cpassword"
                  type="cpassword"
                  value={formik.values.cpassword}
                  onChange={(e) =>
                    formik.setFieldValue("cpassword", e.target.value)
                  }
                  error={formik.touched.cpassword && formik.errors.cpassword}
                  disableNumbers={false}
                  disableSymbols={false}
                  isImportant={true}
                  onBlur={formik.handleBlur}
                  className={styles.formField}
                  focus={formik.values.cpassword ? true : false}
                />
                {formik.touched.cpassword && <ErrorLabel  name="cpassword" formik={formik}  message={formik.errors.cpassword}  /> }
              </div>
              <div className="mb-2" onKeyDown={handleKeyDown}>
                <FormField
                  label="New Password"
                  id="password"
                  name="password"
                  type="password"
                  value={formik.values.password}
                  onChange={(e) =>
                    formik.setFieldValue("password", e.target.value)
                  }
                  error={formik.touched.password && formik.errors.password}
                  disableNumbers={false}
                  disableSymbols={false}
                  isImportant={true}
                  onBlur={formik.handleBlur}
                  className={styles.formField}
                  focus={formik.values.password ? true : false}
                />
                {formik.touched.password && <ErrorLabel  name="password" formik={formik}  message={formik.errors.password}  /> }
              </div>
              <div className="mb-2" onKeyDown={handleKeyDown}>
                <FormField
                  label="New Confirm Password"
                  id="confirm_password"
                  name="confirm_password"
                  type="password"
                  value={formik.values.confirm_password}
                  onChange={(e) =>
                    formik.setFieldValue("confirm_password", e.target.value)
                  }
                  error={formik.touched.confirm_password && formik.errors.confirm_password}
                  disableNumbers={false}
                  disableSymbols={false}
                  isImportant={true}
                  onBlur={formik.handleBlur}
                  className={styles.formField}
                  focus={formik.values.confirm_password ? true : false}
                />
                {formik.touched.confirm_password && <ErrorLabel  name="confirm_password" formik={formik}  message={formik.errors.confirm_password}  /> }
              </div>
             
            </div>

              

          
            </div>

            
          </Form>
        </Modal.Body>
  
        <Modal.Footer>
          <Button variant="secondary" onClick={() => { SetOpenUpdatePassword(0) }}>
            Close
          </Button>
          <Button  variant="primary" onClick={formik.handleSubmit}>
            Update
          </Button>
        </Modal.Footer>
        
      </Modal>
     )
    }
